module.exports = __webpack_public_path__ + "img/c-img-1.9dcd1582.jpg";